import { Component, OnInit } from '@angular/core';
//import { AuthService } from '../shared/services/auth.service';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
    selector: 'app-silent-refres-callback',
    template: `<div></div>`,
})
export class SilentRefreshCallbackComponent implements OnInit {
    constructor(private _authService: AuthService, private _router: Router) {}

    ngOnInit(): void {
        this._authService.finishSilentRefresh().then((_) => {
            // this._router.navigate(['/dashboard'], { replaceUrl: true });
        });
    }
}
